<template>
  <section>
    <!--工具条-->
    <!-- <toolbar
      :buttonList="buttonList"
      @callFunction="callFunction"
    ></toolbar> -->
    <el-form inline>
      <el-form-item label="报销日期">
        <el-date-picker
          v-model="dateRange"
          type="daterange"
          align="right"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          size="small"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-input
          placeholder="查询内容"
          size="small"
          style="width: 120px;"
          v-model="extraInput"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          @click="getList"
          size="small"
          type="primary"
        >查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button
          @click="exportExcel"
          size="small"
          type="success"
        >导出</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table
      :data="dataList"
      highlight-current-row
      v-loading="listLoading"
      style="width: 100%;"
      id="wl"
    >
      <el-table-column
        type="index"
        width="80"
      >
      </el-table-column>
      <el-table-column
        prop="RBDate"
        label="报销日期"
        width=""
        sortable
      />
      <el-table-column
        prop="StaffName"
        label="报销人"
        width=""
        sortable
      />
      <el-table-column
        prop="DepName"
        label="部门"
        width=""
        sortable
      />
      <el-table-column
        prop="CostDepName"
        label="费用归属部门"
        width=""
        sortable
      />
      <el-table-column
        prop="YSDate"
        label="占用预算期间"
        width=""
        sortable
      />
      <el-table-column
        prop="CostTypeName"
        label="费用类型"
        width=""
        sortable
      />

      <el-table-column
        prop="Subject"
        label="项目"
        width=""
        sortable
      />
      <el-table-column
        prop="Amount"
        label="金额"
        width=""
        sortable
      />
      <el-table-column
        prop="Remark"
        label="说明"
        width=""
        sortable
      />
    </el-table>

    <!--工具条-->
    <el-col
      :span="24"
      class="toolbar"
    >
      <el-pagination
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="25"
        :total="total"
        style="float:right;"
      >
      </el-pagination>
    </el-col>
  </section>
</template>

<script>
import FileSaver from 'file-saver'
import * as XLSX from 'xlsx'
import util from '../../../util/date'
import { testapi, getReimburseReport, downloadReimburseReport } from '../../api/api';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import moment from 'moment';
import axios from 'axios';

export default {
  components: { Toolbar },
  data() {
    return {
      filters: {
        name: ''
      },
      dateRange: [],
      extraInput: '',
      dataList: [],
      total: 0,
      buttonList: [],
      page: 1,
      listLoading: false,
    }
  },
  computed: {
    dateStringRange() {
      if (Array.isArray(this.dateRange) && this.dateRange.length === 2) {
        return `${moment(this.dateRange[0]).format('YYYY-MM-DD')},${moment(this.dateRange[1]).format('YYYY-MM-DD')}`;
      } else {
        return '';
      }
    },
  },
  methods: {
    exportExcel2() {
      /* generate workbook object from table */
      let xlsxParam = { raw: true } // 导出的内容只做解析，不进行格式转换
      let wb = XLSX.utils.table_to_book(document.querySelector('#wl'), xlsxParam);//这里的#wl 是表格的id
      /* get binary string as output */
      let wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' });
      try {
        FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), '发票识别结果.xlsx');
      } catch (e) {
        if (typeof console !== 'undefined')
          console.log(e, wbout)
      }
      return wbout
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    getDefaultMonthRange() {
      const today = moment();
      const lastMonthStart = today.clone().subtract(1, 'months').startOf('month');
      const lastMonthEnd = today.endOf('day');
      return [lastMonthStart.toDate(), lastMonthEnd.toDate()];
    },
    //获取列表
    getList() {
      let parkey = this.dateStringRange + ';' + this.extraInput;
      let para = {
        page: this.page,
        key: parkey
      };
      this.listLoading = true;
      getReimburseReport(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.dataList = res.data.response.data;
        this.listLoading = false;
        //NProgress.done();
      });
    },
    async exportExcel() {
      let tmpdata = this.dateStringRange + ';' + this.extraInput;
      // 显示加载指示器（如需）
      this.downloadLoading = true;
      try {
        // 调用下载方法
        const response = await downloadReimburseReport(tmpdata);

        // 在.then中处理下载成功的逻辑，如显示成功提示等
        console.log('下载报销报告成功');

        // 处理成功响应并触发文件下载
        const blob = new Blob([response.data], { type: response.headers['content-type'] });
        const linkElement = document.createElement('a');

        if (window.navigator.msSaveOrOpenBlob) { // 对于IE10+
          window.navigator.msSaveOrOpenBlob(blob);
        } else {
          const objectURL = URL.createObjectURL(blob);
          linkElement.href = objectURL;
          linkElement.download = this.getFileNameFromResponseHeader(response); // 自定义函数，从响应头提取文件名
          document.body.appendChild(linkElement);
          linkElement.click();
          setTimeout(() => {
            document.body.removeChild(linkElement);
            URL.revokeObjectURL(objectURL);
          }, 0);
        }

        // ... 其他处理逻辑 ...

      } catch (error) {
        // 在.catch中处理下载失败的情况，如显示错误提示等
        console.error('下载报销报告失败:', error);
        // ... 其他错误处理逻辑 ...
      }
    },
    exportExcel3() {
      // // if (file.status == 'success') {
      // var fileurl = this.huanjing == 'production' ? 'http://192.168.80.73:1003/api/reimbursement/DownReimburseReport/' : 'http://localhost:8081/api/reimbursement/DownReimburseReport/';
      // let parkey = this.dateStringRange + ';' + this.extraInput;
      // axios({
      //   // 用axios发送post请求
      //   method: "post",
      //   url: fileurl + "?tmpdata=" + parkey, // 请求地址 ，也可以传递参数
      //   responseType: "blob" // 表明返回服务器返回的数据类型
      // }).then((res) => {
      //   var content = res.data;
      //   var blob = new Blob([content]);
      //   var url = URL.createObjectURL(blob);
      //   let link = document.createElement('a')
      //   link.style.display = 'none'
      //   link.href = url
      //   link.setAttribute('download', file.name)
      //   document.body.appendChild(link)
      //   link.click()
      // });
      // }
    },
    getFileNameFromResponseHeader(response) {
      const now = new Date(); // 获取当前日期时间对象
      const year = now.getFullYear().toString().padStart(4, '0'); // 获取年份并补零至四位
      const month = (now.getMonth() + 1).toString().padStart(2, '0'); // 获取月份（注意月份是从0开始的，所以需要加1），并补零至两位
      const day = now.getDate().toString().padStart(2, '0'); // 获取日期并补零至两位
      return '报销统计' + `${year}${month}${day}` + '.xlsx';
    }
  },
  mounted() {
    this.dateRange = this.getDefaultMonthRange();
    this.getList();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  }

}

</script>

<style scoped>
</style>
